import React, { useEffect, useRef } from "react";
import { useDataFormContext } from "@/context/FormDataContext";
import { Button, Grid2 } from "@mui/material";
import { Wrapper } from "./styles";

/**
 * @returns ProposalRefused component
 */
export default function ProposalRefused(): React.JSX.Element {
  const { setCurrentFormStep, setCurrentFormVariation } = useDataFormContext();

  const inputRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (inputRef.current) {
      const height = inputRef?.current?.offsetHeight;
      window.parent.postMessage(
        ["setHeight", `${height + (height * 85) / 100}`],
        "*"
      );
    }
  }, []);

  return (
    <div ref={inputRef}>
      <Wrapper>
        <h2>Proposta Recusada!</h2>
        <p>
          <span>
            Infelizmente não temos uma proposta para a sua cota no momento.
          </span>
        </p>
        <p>
          Fique atento ao seu email ou whatsapp. Se tivermos novidades
          entraremos em contato. Abaixo você pode nos enviar uma outra cota para
          uma nova avaliação
        </p>
      </Wrapper>

      <Grid2 container spacing={3} justifyContent={"center"}>
        <Grid2 size={{ xs: 12, sm: 5 }}>
          <Button
            fullWidth
            variant="goFoward"
            onClick={() => {
              setCurrentFormStep(0);
              setCurrentFormVariation("all");
            }}
          >
            Enviar outra cota
          </Button>
        </Grid2>
      </Grid2>
    </div>
  );
}
